module.exports = "//static.hsappstatic.net/payments-enrollment-embed-lib/static-1.14936/images/StripeLogo.svg"